(function () {

  'use strict';

  angular.module('specsguardApp')
    .factory('noCacheInterceptor', noCacheInterceptor);

  function noCacheInterceptor () {
    return {
      request: function (config) {
        if (config.method === 'GET' && config.url.substring(1, 4) === 'api') {
          const separator = config.url.indexOf('?') === -1 ? '?' : '&';
          config.url = config.url + separator + 'noCache=' + new Date().getTime();
        }
        return config;
      }
    };
  }

})();
